import { newToolFilterOAuthMcp } from "../oauth.ts";

export const webflowMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/686294e263eb7e215bd232f7/686d53d0446d4237b2f38c5f_webclip.png",
  url: "https://mcp.webflow.com/mcp",
  label: "Webflow",
});
